import { createPortal } from 'react-dom';

type NotificationsPortalProps = {
  children: React.ReactNode;
};

const NotificationsPortal = ({ children }: NotificationsPortalProps) => {
  const id = 'notifications';
  const el = document.getElementById(id);
  if (!el) {
    throw new Error(`'#${id}' container element was not found`);
  }

  return createPortal(children, el, id);
};

NotificationsPortal.displayName = 'NotificationsPortal';
export { NotificationsPortal };
